import { BasicControl, CURSOR_TYPE, DYMODE_MODE, Listeners, MOUSE, Point, Sphere, SphereT, TnEngineContext, TnEngineExtraContext, ViewEditor, dymode } from "pytha";
import { ARCHI_CTRL_TYPE } from "../enums/archibase-control-type";
import { Vector3 } from "three";
import { ARCHIBASE_SINGAL } from "../enums/archibase-singal";
import { MonitorColorSphereT } from "../models/monitor-object/MonitorSphereT";

/**
 * 定风位
 * 
 * 方式：指定点布置
 */
export class SelectWindLocationControl extends BasicControl {
    id = ARCHI_CTRL_TYPE.ADD_WIND_LOCATION_MONITOR_OBJECR;

    point_down: Point = new Point(); // 鼠标点击点
    point_move: Point = new Point(); // 鼠标移动点

    capturePoint: Vector3; // 捕捉点

    helpSphere: MonitorColorSphereT = new MonitorColorSphereT(); // 临时的风位点图元

    needInit: boolean;

    context: TnEngineContext;
    extraContext: TnEngineExtraContext;

    options = {
        0: [
            { name: '退出', key: 'X' },
        ],
    }

    constructor(editor: ViewEditor, listeners: Listeners) {
        super();
        this.needInit = true;
        this.editor = editor;
        this.listeners = listeners;
        this.context = TnEngineContext.getInstance();
        this.extraContext = TnEngineExtraContext.getInstance();
        this.listeners.signals.needCapture.dispatch();
        editor.renderer.domElement.addEventListener('pointermove', this.onPointerMove);
        editor.renderer.domElement.addEventListener('pointerdown', this.onPointerDown);
        this.listeners.signals.onDymodeChanged.add(this.onDymodeChanged);
        this.listeners.signals.onPointCapture.add(this.onPointCapture);
        this.listeners.signals.onCursorChange.dispatch(CURSOR_TYPE.CROSS);
        this.editor.selectControl.setEnabled(false);
        this.extraContext.dymodeContext.enabled = true;
        this.extraContext.dymodeContext.setMode(DYMODE_MODE.POINT);
        this.listeners.signals.sendToDymodeTip.dispatch('指定风位点:');
        this.extraContext.stmodeContext.setStmode('指定风位点');
        // 构造临时的风位点图元
        this.generateHelpShere();
        console.log('SelectWindLocationControl added');
    }

    dispose(): void {
        this.editor.renderer.domElement.removeEventListener('pointermove', this.onPointerMove);
        this.editor.renderer.domElement.removeEventListener('pointerdown', this.onPointerDown);
        this.listeners.signals.onDymodeChanged.remove(this.onDymodeChanged);
        this.listeners.signals.onPointCapture.remove(this.onPointCapture);
        this.editor.selectControl.setEnabled(true);
        this.listeners.signals.noNeedCapture.dispatch();
        this.editor.clampControl.enabled = true;
        this.extraContext.dymodeContext.enabled = false;
        if (this.helpSphere && this.helpSphere.viewObj && this.helpSphere.viewObj.parent) {
            this.helpSphere.viewObj.parent?.remove(this.helpSphere.viewObj);
        }
        console.log('SelectWindLocationControl removed');
    }

    generateHelpShere = () => {
        // 2cm的半径
        let center = new Point(this.extraContext.mousePosContext.x, this.extraContext.mousePosContext.y, this.extraContext.mousePosContext.z);
        let sphere = new Sphere(center, 20);
        this.helpSphere = new SphereT(sphere);
        this.helpSphere.render();
        this.extraContext.sceneContext.scene.add(this.helpSphere.viewObj);
    }

    onPointCapture = (point) => {
        this.capturePoint = point;
    }

    private firstIn = true;
    private _dir = new Vector3();

    onPointerMove = (event) => {
        if (!!!this.helpSphere) {
            return;
        }
        this.point_move.set(this.extraContext.mousePosContext.x, this.extraContext.mousePosContext.y, this.extraContext.mousePosContext.z);

        if (this.capturePoint) {
            this.point_move.copy(this.capturePoint);
        }
        this._dir.set(this.point_move.x - this.helpSphere._geo.center.x, this.point_move.y - this.helpSphere._geo.center.y, this.point_move.z - this.helpSphere._geo.center.z);
        let length = this._dir.length();
        this._dir.normalize();
        this.helpSphere.move(this._dir, length);
        this.helpSphere.updateViewGeometry();
        this.listeners.signals.needRender.dispatch();
    }

    onPointerDown = (event) => {
        if (event.button === MOUSE.RIGHT) {
            this.listeners.signals.onOpeCommandControlEnd.dispatch();
            return;
        }
        if (event.button !== MOUSE.LEFT) return;
        if (!!!this.helpSphere) {
            this.listeners.signals.onOpeCommandControlEnd.dispatch();
        }
        let rect = this.editor.renderer.domElement.getBoundingClientRect();
        let x = (event.clientX - rect.x) / rect.width * 2 - 1;
        let y = -(event.clientY - rect.y) / rect.height * 2 + 1;
        this.context.ucsContext.unprojectCursorPoint(x, y, this.editor.camera, this.point_down);
        // 有捕捉点，优先捕捉
        if (this.capturePoint) {
            this.point_down.copy(this.capturePoint);
        }
        this.assemble();
    }

    assemble() {
        this._dir.set(this.point_down.x - this.helpSphere._geo.center.x, this.point_down.y - this.helpSphere._geo.center.y, this.point_down.z - this.helpSphere._geo.center.z);
        let length = this._dir.length();
        this._dir.normalize();
        this.helpSphere.move(this._dir, length);
        this.helpSphere.updateViewGeometry();
        this.listeners.getSignal(ARCHIBASE_SINGAL.onSelectMonitorObjectFinish).dispatch(this.helpSphere);
        this.listeners.signals.onOpeCommandControlEnd.dispatch();
    }

    onDymodeChanged = (value: dymode) => {
        if (value.mode === DYMODE_MODE.CHOOSE) {
            if (value.choose === 'X') {
                //退出
                this.listeners.signals.onOpeCommandControlEnd.dispatch();
            }
        } else if (value.mode === DYMODE_MODE.POINT) {
            this.point_down.set(value.x, value.y, value.z);
            this.assemble();
        }
    }

}